var _polyline, _polyline2, _polyline3, _polyline4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnorouter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "38.63 92.56 38.09 122.28 120.46 85.88 119.49 56.91"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fillOpacity: 0.6,
    points: "119.49 157.79 120.46 128.5 71.85 107.36 38.09 122.28"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "202.29 157.44 202.84 127.72 120.46 164.12 121.44 193.09"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    fillOpacity: 0.6,
    points: "121.44 92.21 120.46 121.5 169.08 142.64 202.84 127.72"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.46,20.8c-57.55,0-104.2,46.65-104.2,104.2s46.65,104.2,104.2,104.2,104.2-46.65,104.2-104.2S178.01,20.8,120.46,20.8ZM120.46,225c-55.23,0-100-44.77-100-100S65.24,25,120.46,25s100,44.77,100,100-44.77,100-100,100Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnorouter);
export default __webpack_public_path__ + "static/media/unorouter.58f28cd7ec2af4addcd8a60cc18083a9.svg";
export { ForwardRef as ReactComponent };